function onInput(el, ele, binding, vnode) {
    function handle() {
        let IntegerLength = 0 // 期望的最多整数位
        // 只保留数字
        let val = ele.value
        // modifiers为修饰符对象，传入了float，则其float属性为true
        if (binding.modifiers.float) {
            // 清除"数字"和"."以外的字符
            val = val.replace(/[^\d.]/g, '')
            // 只保留第一个, 清除多余的
            val = val.replace(/\.{2,}/g, '.')
            const frontVal = val.slice(0, val.indexOf('.') + 1)
            const endVal = val.slice(val.indexOf('.') + 1).replace(/\./g, '')
            val = frontVal + endVal
            // 第一个字符如果是.号，则补充前缀0
            val = val.replace(/^\./g, '0.')
            if (typeof binding.value !== 'undefined') {
                // 期望保留的最大小数位数
                let pointKeep = 0
                if (typeof binding.value === 'string' ||
                    typeof binding.value === 'number') {
                    pointKeep = parseInt(binding.value)
                } else if (Array.isArray(binding.value)) {
                    pointKeep = parseInt(binding.value[1])
                    IntegerLength = parseInt(binding.value[0])
                }
                if (!isNaN(pointKeep)) {
                    if (!Number.isInteger(pointKeep) ||
                        pointKeep < 0) {
                        pointKeep = 0
                    }
                    const str = `^(\\d+)\\.(\\d{${pointKeep}}).*$`
                    const reg = new RegExp(str)
                    if (pointKeep === 0) {
                        // 不需要小数点
                        val = val.replace(reg, '$1')
                    } else {
                        // 通过正则保留小数点后指定的位数
                        val = val.replace(reg, '$1.$2')
                    }
                }
            }
        } else {
            let max = 0

            if (typeof binding.value === 'object') {
                max = binding.value.max
            }
            val = ele.value.replace(/[^\d]/g, '')
            if (max && val > max) val = max + ''
        }
        if (val) {
            // 获取整数
            let integerNumber = val.split('.')[0]
            if (integerNumber.length > 1) {
                integerNumber = integerNumber.slice(0, -1).replace(/^0*/, '') + integerNumber.slice(-1)
                if (IntegerLength) {
                    // 如果有整数位最多的限制
                    if (integerNumber > 0) {
                        integerNumber = integerNumber.slice(0, IntegerLength)
                    }
                }
            }
            if (val.split('.').length > 1) {
                // 说明有小数点
                val = integerNumber + '.' + val.split('.')[1]
            } else {
                val = integerNumber
            }
        }
        ele.value = val
        if (vnode.componentInstance) {
            vnode.componentInstance.$emit('input', ele.value)
        } else {
            vnode.elm.dispatchEvent(new CustomEvent('input', ele.value))
        }
    }
    return handle
}
export const clickoutside = {
    // 初始化指令
    bind(el, binding, vnode) {
        function documentHandler(e) {
            // 这里判断点击的元素是否是本身，是本身，则返回
            if (el.contains(e.target)) {
                return false
            }
            // 判断指令中是否绑定了函数
            if (binding.expression) {
                // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
                binding.value(e)
            }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = documentHandler
        document.addEventListener('click', documentHandler)
    },
    update() { },
    unbind(el, binding) {
        // 解除事件监听
        document.removeEventListener('click', el.__vueClickOutside__)
        delete el.__vueClickOutside__
    }
}
export const numberInput = {
    bind(el, binding, vnode) {
        const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
        ele.addEventListener('input', onInput(el, ele, binding, vnode), false)
    }
}